'use strict';

import axios from 'axios';
import getCookie from '../../utils/getCookie';
import {DateTime} from 'luxon';

let inventoryPromise;
const now = DateTime.local({ zone: "America/New_York" });

function getRequestConfig() {
    const config = {};
    if (window.AppConfig.request_auth) {
        config.auth = window.AppConfig.request_auth;
    }
    return config;
}

function getInventory() {
    if (inventoryPromise) {
        return inventoryPromise
    }
    const userMOS = getCookie('_current_mos');
    const mos = userMOS ? userMOS : window.AppConfig.defaultModeOfSale;
    const url = window.AppConfig.eventsEndpoint.replace('{mos}', mos);

    return inventoryPromise = axios.get(url, getRequestConfig())
        .then(response => response.data)
        .then(processPerformances);
}

function getPerformances(prodSeasonNos, perfNos) {
    return getInventory().then(data => {
        return data.filter(perf => perfNos.indexOf(perf.perf_no) > -1 || prodSeasonNos.indexOf(perf.prod_season_no) > -1);
    });
}

function processPerformances(perfs) {
    return perfs.map(perf => {
        perf.perf_date_luxon = DateTime.fromISO(perf.perf_date.replace(/[+-]\d+:\d+$/, ''));
        if (perf.initial_on_sale_date) {
            perf.on_sale_date_luxon = DateTime.fromISO(perf.initial_on_sale_date);
        } else if (perf.on_sale_date) {
            perf.on_sale_date_luxon = DateTime.fromISO(perf.on_sale_date);
        } else {
            perf.on_sale_date_luxon = false;
        }
        perf.onSale = () => {
            return perf.on_sale_date_luxon && perf.on_sale_date_luxon < DateTime.utc();
        }
        perf.sort = parseInt(perf.perf_date_luxon.toFormat('X'), 10);
        perf.day = perf.perf_date_luxon.toFormat('ccc');
        perf.month_date = perf.perf_date_luxon.toFormat('LLL d');
        perf.time = perf.perf_date_luxon.toFormat('h:mm a');

        perf.keywords.push({
            keyword_no: perf.perf_date_luxon.toFormat('c'), // Day of the week
            keyword: perf.perf_date_luxon.toFormat('cccc'),
            category_no: -1,
            category: 'Days',
            sort: perf.perf_date_luxon.toFormat('E'),
        });
        return perf;
    }).sort((a, b) => {
        return a.sort < b.sort ? -1 : a.sort > b.sort ? 1 : 0;
    }).filter(perf => perf.perf_date_luxon > now);
}

export default {
    getPerformances,
    getInventory
}